import BaseModelInstance from './base.model'
import { UserCorpEmail as ModelDefinition } from './model-definitions'

class UserCorpEmail extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserCorpEmail
